import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const AdminOrderStatusChart = ({ data = [], isLoading }) => {
    // Expected: [{ name: "Active", value: 25, color: "#f6c23e" }, ...]
    const chartData = Array.isArray(data) ? data : [];

    return (
        <Card sx={{ borderRadius: 3, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
            <CardContent>
                <Typography variant="h6" fontWeight={700} mb={2}>
                    Order Status Distribution
                </Typography>

                {isLoading ? (
                    <Skeleton variant="circular" width={250} height={250} sx={{ margin: 'auto' }} />
                ) : (
                    <Box sx={{ height: 350, width: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie data={chartData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={5} dataKey="value">
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend verticalAlign="bottom" height={36} iconType="circle" />
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

AdminOrderStatusChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
            color: PropTypes.string
        })
    ),
    isLoading: PropTypes.bool
};

export default AdminOrderStatusChart;
